import { render, staticRenderFns } from "./LoaderSend.vue?vue&type=template&id=3190d352"
import script from "./LoaderSend.vue?vue&type=script&lang=js"
export * from "./LoaderSend.vue?vue&type=script&lang=js"
import style0 from "./LoaderSend.vue?vue&type=style&index=0&id=3190d352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports